@if (open) {
  <div class="fixed inset-0 z-[70] flex items-end sm:items-center justify-center sm:p-4">
    <div class="absolute inset-0 bg-gray-900/60 backdrop-blur-sm" (click)="cancel()"></div>

    <div class="relative bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full max-w-3xl max-h-[92dvh] sm:max-h-[90vh] flex flex-col">
      <div class="sm:hidden mx-auto mt-3 h-1 w-10 rounded-full bg-gray-300 flex-shrink-0"></div>

      <!-- Header -->
      <div class="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200">
        <div>
          <h2 class="text-lg font-semibold text-gray-900">Set Location</h2>
          <p class="text-xs text-gray-500 mt-0.5">Click the map to mark the member's home, or drag the marker to adjust.</p>
        </div>
        <button type="button" (click)="cancel()"
                class="p-1.5 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div class="flex-1 overflow-y-auto overscroll-contain px-4 sm:px-6 py-5">
        <app-location-picker [value]="draft" (valueChange)="onDraftChange($event)"></app-location-picker>
      </div>

      <!-- Footer -->
      <div class="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-3 px-4 sm:px-6 py-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:pb-4 border-t border-gray-200 bg-gray-50 sm:rounded-b-2xl">
        <button type="button" (click)="cancel()"
                class="w-full sm:w-auto max-md:tap-target px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-white transition-colors">
          Cancel
        </button>
        <button type="button" (click)="confirm()"
                class="w-full sm:w-auto max-md:tap-target inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors">
          Use this location
        </button>
      </div>
    </div>
  </div>
}
